<template>
    <div>
      <section  class="navbarsection" style="margin-top: -50px;">
            <div class="txtdata">
              <h1  style="padding-top: 200px;"></h1>
            </div>
              <div class="videosection" >
                <div  v-show="pvisvideo === true && pvpictureimage === false ">
                  <Transition class="transition thing">
                    <video-background 
                      playbackRate=0.98
                      :src="src"
                      :poster="poster"
                      :class="`thing playercss`"
                      :style="`height: 600px;`">
                    </video-background>
                  </Transition>
                </div>
              
                  <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                  </div>
        
                  <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                  v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
         
            </div>
            <div class="overlay"></div>
            <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
              <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
            </div>
          </section>
  
   <div class="seven3css">
    <SeventyThirtysection :LeftsideText="sustsec1text" :RightsideText="susthighlight" />
    <div class="col-xs-12 col-sm-12 col-md-8">
        <img :src="`${myPicUrl}${newsphoto}`" class="imagecss"/>
    </div>
   </div>
<!--   
   <div class="allreports">
    <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
    :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
    :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" 
    :bgimage="bgimage" :showbg="showbg" :showrptfulltext="showrpttext"
    />
  </div> -->
  

    </div>
  </template>
  
  <script>

  import SeventyThirtysection from '@/components/SeventyThirtysection.vue';
  import AllReports from '@/components/AllReports.vue';
  require('@/assets/css/pannellium-2.5.css');
  require('@/assets/css/video-js.css');
  require('@/globalDeclare.js');
  import axios from 'axios';
  
  
  export default {
    name: 'AboutView',
    components: {
    SeventyThirtysection, AllReports
  },
  data() {
    return {
    videoimage: [],
    imagetext: '',
    src: '',
    playrate: '',
    poster: '',
    // pvwebm: '',
    // pvmp4: '',
    pvstyle: '',
    pvsrc: '',
    pvisvideo: false,
    pvpanorama1: '',
    pvpanorama2: '',
    pvpanorama3: '',
    pvhotspot1: '',
    pvhotspot2: '',
    pvhotspot3: '',
    showVideo: false,
    showPanorama: false,
  
  
    // corpgovernpolicy: [],
    sustsec1text: '',
    susthighlight: '',
  
    // SliderData: [],
    bgimage: '',
    newsphoto: '',
    showrpttext: false,
    showbg: false,
  
  reportpresentation: [],
  lastrecordsreportpresent: [],
    myPicUrl: '',
    }
  },
  methods: {
  
  },
  mounted() {
    this.myPicUrl = myUrlPath
    axios.get('allpagespv/managementapproach').then(
      response => {
        this.videoimage = response.data
        
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
  
        // let pvisvideo1 = this.videoimage.pvisvideo
        // this.pvisvideo = pvisvideo1
  
  
        if (this.pvisvideo === 'true') {
          this.src = this.videoimage.pvmp4
          this.showVideo
          if (response.status === 403 ) {
          e = "No data available"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
          });
          }
          else if (response.status === 404) {
            e = "Page Not Found!"
            const toast = useToast();
            toast.success(e, {
            timeout: 6000
          });
          }
        }
        else{
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -237.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.6,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                    hotSpots: [
                        {
                            pitch: 4,
                            yaw: 21.8,
                            type: "scene",
                            sceneId: "anotherhotspot",
                            text: this.pvhotspot1,
                        }
                    ]
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "lasthotspot",
                              text: this.pvhotspot2,
                          }
                      ]
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "hotspotoffice",
                              text: this.pvhotspot3,
                          }
                      ]
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
        console.log(this.src)
    })
    .catch((error) => {
        console.log(error)
      })
     //------------corpgovernance info---------------
    axios.get('getsustainabilityoverview/').then(
      response => {
          this.sustsec1text = response.data[0].sustsec1text
          // this.cpimg = response.data.cpimg
    })
    .catch((error) => {
        console.log(error)
      })
  
  
  
     //------------corpgovernpolicy table info---------------
    //  await axios.get('getcorpgovernpolicyinfo/policiesandcommitment').then(
    //   response => {
    //       this.corpgovernpolicy = response.data
    // })
    // .catch((error) => {
    //     console.log(error)
    //   })
    //------------all highlights---------------
    axios.get('getallhiglights/managementapproach').then(
      response => {
          this.susthighlight = response.data[0].highlightdesc
    })
    .catch((error) => {
        console.log(error)
      })
    
    //------------all sliders(generic)---------------
    // await axios.get('getallslidersgeneric/policiesandcommitment').then(
    //   response => {
    //       this.SliderData = response.data
    // })
    // .catch((error) => {
    //     console.log(error)
    //   })
  
  //------------Get Reports---------------
  axios.get('reportpresentationlisting/managementapproach').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.showrpttext = response.data.showrptfulltext
        this.bgimage = response.data.bgimage
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })
    //------------all sliders(generic)---------------
  axios.get('getbgimage/managementapproach').then(
      response => {
          this.bgimage = response.data[0].bgimageupload
    })
    .catch((error) => {
        console.log(error)
      })

    //------------all News Photos(generic)---------------
  axios.get('getnewsphotos/managementapproach').then(
      response => {
          this.newsphoto = response.data[0].newsphoto
          console.log(this.newsphoto)
    })
    .catch((error) => {
        console.log(error)
      })
      


  }
  }
  </script>
  
  <style scoped>
 
  .section03 {
    height: 300px;
  }
  .container {
    display: grid;
    height: 100vh;;
    grid-template-columns: 1fr;
    grid-template-rows: .2fr 1.2fr .2fr;
    grid-template-areas: 
    "nav nav nav" 
    "main main main" 
    "footer footer footer";
    grid-gap: 0.2rem;
    font-family: "Inter", sans-serif;
    font-size: 800;
    font-size: 12px;
    color: #234234;
    text-align: center;
  }
  
  html { 
    height: 100%;
    margin:0px;
    background: url('../assets/slide-5.jpg') no-repeat center center;
    background-size: cover;
    background-attachment: fixed;
  }
  
  main {
    background: white;
    grid-area: main;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-radius: 0px;
    margin-top:-5px;
  }
  .formatrow {
    margin-top: 340px;
    padding-left: 100px;
    padding-right: 100px;
  }
  .seven3css {
    margin-top: 200px;
  }
  
  .reportpresentcss {
    margin-top: 300px;
  }
  .imagecss {
    width: 80%;
    padding-left: 50px;
    padding-bottom: 100px;
  }
  .videosection {
    margin-top: -60px;
    height: 600px;
    width: 100%;
    background-color: #003;
  }
  
   .overlay {
    opacity: 0.99;
    width: 100%;
    height: 600px;
    background: linear-gradient(to bottom, #003, transparent);
    margin-top: -600px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #003;
  }
  @media only screen and (max-width: 600px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
 
      .col-md-8 {
        margin-bottom: 100px;
      }

  }
  
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
 
      .col-md-8 {
        margin-bottom: 100px;
      }
  }
  
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
  }
  
  
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {

  }
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
 
  }
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
  
  }
  
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1600px) {
  
  }
  </style>
  